var callcenterTable = {
  templateUrl: './table.html',
  controller: 'CallcenterTableController'
};

angular
  .module('components.callcenter')
  .component('callcenterTable', callcenterTable);